import React from 'react';
import { MetaTags } from 'app/models';
import { useGallery, useSite, useSiteMap, useTranslations } from 'app/hooks';

const PersonMetaData = ({ itemProp, metaContent }) => (
  <div
    className="gallery-asset-schema"
    itemScope
    itemProp={itemProp}
    itemType="http://schema.org/Person"
  >
    <meta
      itemProp="name"
      content={metaContent}
    />
  </div>
);

const Schema = ({ asset }) => {
  const t = useTranslations();
  const gallery = useGallery();
  const site = useSite();
  const siteMap = useSiteMap();
  const meta = new MetaTags(asset, site, siteMap, t);

  const schemaItemType = () => {
    switch (asset.mediaType.toLowerCase()) {
      case 'photo':
      case 'photography':
        return 'http://schema.org/Photograph';
      default:
        return 'http://schema.org/MediaObject';
    }
  };

  const copyrightNotice = () =>
    site.isGetty()
      ? `\u00A9Getty Images, credit: ${meta.artist()}`
      : `\u00A9iStock, credit: ${meta.artist()}`;

  const getUploadDate = () => meta.uploadDate();

  return (
    <div
      className="gallery-asset-schema"
      itemScope
      itemProp={meta.itemProp()}
      itemType={schemaItemType()}
    >
      <meta
        itemProp="usageInfo"
        content={meta.usageInfo()}
      />
      <div
        className="gallery-asset-schema"
        itemScope
        itemProp={meta.itemProp()}
        itemType={meta.itemType()}
      >
        <PersonMetaData
          itemProp="author"
          metaContent={meta.artist()}
        />
        <PersonMetaData
          itemProp="creator"
          metaContent={meta.artist()}
        />
        <meta
          itemProp="acquireLicensePage"
          content={meta.seoAssetLandingUrl()}
        />

        <meta
          itemProp="caption"
          content={meta.seoCaptionOrTitle()}
        />
        <meta
          itemProp="contentUrl"
          content={meta.seoContentUrl()}
        />
        <meta
          itemProp="copyrightNotice"
          content={copyrightNotice()}
        />
        <meta
          itemProp="creditText"
          content={meta.artist()}
        />
        <meta
          itemProp="description"
          content={meta.seoDescription()}
        />
        <meta
          itemProp="license"
          content={meta.seoLicenseUrl()}
        />
        <meta
          itemProp="name"
          content={meta.seoTitle()}
        />
        <meta
          itemProp="thumbnailUrl"
          content={meta.seoThumbUrl()}
        />
        <meta
          itemProp="uploadDate"
          content={getUploadDate()}
        />
        {gallery.isFilm() &&
          ((
            <meta
              itemProp="duration"
              content={meta.seoDuration()}
            />
          ),
          (
            <meta
              itemProp="videoFrameSize"
              content={meta.seoVideoFrameSize()}
            />
          ),
          (
            <meta
              itemProp="videoQuality"
              content={meta.seoVideoQuality()}
            />
          ))}
      </div>
    </div>
  );
};

export default Schema;
